import { CalculationKeyboardButton } from "./CalculationKeyboardButton";
import { CalculationKeyboardRoot } from "./CalculationKeyboardRoot";

export const CalculationKeyboard = {
  Root: CalculationKeyboardRoot,
  Button: CalculationKeyboardButton,
};
